import { Component, OnInit } from '@angular/core';
import {SourcesService} from './sources.service';

@Component({
  selector: 'app-sources',
  templateUrl: './sources.component.html',
  styleUrls: ['./sources.component.css'],
  providers: [SourcesService]
})
export class SourcesComponent implements OnInit {

  constructor(private sourceService: SourcesService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/sources/sources.component.ts